import React from "react";
import {
  Modal,
  Box,
  Typography,
  Grid,
  IconButton,
  Button,
  // useTheme,
  useMediaQuery,
  CircularProgress,
} from "@mui/material";
import ndcBg from "../../assets/images/ndc-bg.png";
import closeIcon from "../../assets/images/close.png";
import { resendInviteStart } from "../../redux/slices/sellerSlice";
import { useDispatch, useSelector } from "react-redux";

const ModalFunction = ({ open, onClose, userName, sellerId }) => {
  // const theme = useTheme();

  const {loading} = useSelector((state) => state.seller);

  const isMobile = useMediaQuery((theme) =>
    theme.breakpoints.between("sm", "md")
  );

  const dispatch = useDispatch();
  const handleResendInvite = () => {
    dispatch(resendInviteStart({seller_id:sellerId}));
    onClose();
  };
  return (
    <Modal open={open} onClose={onClose}>
      <Box
        item
        xs={12}
        sx={{
          position: "absolute",
          top: { sm: "50%", md: "30%", lg: "50%" },
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          boxShadow: 24,
          maxHeight: "90vh",
          overflowY: "auto",
          width: isMobile ? "90%" : "44.875rem",
          borderRadius: "1rem",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            background: `url(${ndcBg})`,
            minHeight: "5rem",
            borderRadius: "1rem",
            backgroundRepeat: "round",
            px: isMobile ? "1.5rem" : "2rem",
            justifyContent: "space-between",
            alignItems: "center",
            display: "flex",
          }}
        >
          <Typography
            sx={{
              fontSize: isMobile ? "1.2rem" : "2.25rem",
              fontWeight: 700,
              lineHeight: "3rem",
              fontFamily: "Open Sans",
            }}
          >
            Resend activation details
          </Typography>

          <IconButton
            onClick={onClose}
            sx={{
              height: "2.5rem",
              width: "2.5rem",
            }}
          >
            <img src={closeIcon} alt="close icon" />
          </IconButton>
        </Box>
        <Grid>
          <Typography
            sx={{
              fontSize: isMobile ? "0.8rem" : "1rem",
              fontWeight: 400,
              color: "#000",
              textAlign: "center",
              mt: "2rem",
            }}
          >
            Are you sure you want to resend an email to{" "}
            <span style={{ fontWeight: 600 }}>{userName}</span>
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: isMobile ? "column" : "row",
              justifyContent: "space-between",
              alignItems: "center",
              mt: "2rem",
              p: isMobile ? "1rem" : "2rem", // Adjust padding for mobile
              gap: {
                xs: "1rem", // Add spacing between buttons for mobile
              },
            }}
          >
            <Button
              fullWidth
              variant="contained"
              sx={{
                textTransform: "none",
                fontFamily: "Open Sans",
                fontWeight: 700,
                fontSize: "16px",
                lineHeight: "20px",
                height: "41px",
                width: isMobile ? "100%" : "120px",
                pl: "25px",
                pr: "25px",
                borderRadius: "24px",
              }}
              onClick={onClose}
            >
              No
            </Button>
            <Button
              variant="outlined"
              sx={{
                textTransform: "none",
                fontFamily: "Open Sans",
                fontWeight: 700,
                fontSize: "16px",
                lineHeight: "20px",
                height: "41px",
                width: isMobile ? "100%" : "120px",
                pl: "25px",
                pr: "25px",
                borderRadius: "24px",
              }}
              onClick={handleResendInvite}
            >
              {loading ? (
                <CircularProgress
                  size={20}
                  sx={{ color: "white" }}
                ></CircularProgress>
              ) : (
                "Yes"
              )}
            </Button>
          </Box>
        </Grid>
      </Box>
    </Modal>
  );
};

export default ModalFunction;
